import Configuration from '@/src/components/Configuration/Configuration';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import TCModals from 'src/constrains/TermsAndConditionsSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
const TermsAndConditions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const p: any = useParams();

  const { uuid } = p;
  const { data, onChange, setHasModified, tcs, error, id, disableEdit } = props;
  const { tcEmptyError, setTcEmptyError } = error || {};
  const [visible, setVisible] = React.useState(false);

  // const currentTcs = (data || []).map((i) => {
  //   const termCondition = get(i, 'termCondition');
  //   return termCondition;
  // });
  const _setHasModified = () => {
    if (setHasModified) setHasModified(true);
  };

  const handleOnClose = () => {
    setVisible(false);
  };

  const handleOnFieldSort = (e) => {
    _setHasModified();
    if (onChange) {
      onChange(e);
    }
  };

  const handleOnAdd = () => {
    // const sD = data[index];
    setVisible(true);
  };

  const handleOnChange = (tcs) => {
    _setHasModified();
    if (setTcEmptyError) setTcEmptyError(false);
    if (onChange) {
      onChange(tcs);
    }
  };

  const handleOnDelete = (index) => {
    _setHasModified();
    const _data = [...(data || [])];
    _data.splice(index, 1);
    if (onChange) {
      onChange(_data);
    }
  };

  return (
    <React.Fragment>
      {visible && (
        <TCModals
          tcs={tcs}
          selectedItems={data}
          onOk={handleOnChange}
          onCancel={handleOnClose}
          visible={visible}
        />
      )}
      <DroppableTable
        //rowSelection={row}
        error={
          tcEmptyError ? getI18n('general.selectTermsConditionsError') : null
        }
        pagination={false}
        rowKey={(record) => {
          const uuid = get(record, 'uuid');
          return uuid;
        }}
        dataSource={data || []}
        columns={col(handleOnDelete, disableEdit, { getI18n })}
        id={id}
        onTableChange={handleOnFieldSort}
        hideAllDragHandlers={disableEdit}
        // rowDeleteFunc={deleteProduct}
      />
      <Button
        onClick={handleOnAdd}
        type='primary'
        className={css.addNew}
        disabled={disableEdit}>
        {getI18n('general.selectTermsConditions')}
      </Button>
      <div className={css.configContainer}>
        <Configuration
          configStart={`${getI18n('general.gotoStore')} > ${getI18n(
            'general.sider.salesChannel',
          )}`}
          configLink={getI18n('general.legal')}
          linkTo={`/salesChannel/legalPage/list/${uuid}`}
          configEnd={getI18n('general.manageTermsConditions')}
        />
      </div>
    </React.Fragment>
  );
};
export default TermsAndConditions;

const col = (onDelete, disableEdit, { getI18n }) => {
  return [
    {
      title: getI18n('general.termsConditionsName'),
      key: 'name',
      default: true,
      childGenerate: (url, record) => {
        const name = get(record, 'name');
        return (
          <NoWrapContainer>
            <GlobalTooltip title={name}>{name}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      minWidth: 320,
    },
    {
      title: getI18n('general.agreementRequiredOptional'),
      key: 'required',
      default: true,
      childGenerate: (url, record) => {
        const required = get(record, 'setAgreementAsRequired');
        return required
          ? getI18n('general.required')
          : getI18n('general.optional');
      },
      width: 250,
    },
    {
      title: getI18n('general.defaultCheckboxStatus'),
      key: 'default',
      default: true,
      childGenerate: (url, record) => {
        const checked = get(record, 'defaultStatusChecked');
        return checked
          ? getI18n('general.checked')
          : getI18n('general.unchecked');
      },
      width: 250,
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          key: 'Actions',
          default: true,
          childGenerate: (url, record, index) => {
            return (
              <Actions
                onDelete={() => {
                  onDelete(index);
                }}
              />
            );
          },
          width: 190,
        },
  ];
};
